import { render, staticRenderFns } from "./VueCheckbox.vue?vue&type=template&id=62f44558&scoped=true&"
import script from "./VueCheckbox.vue?vue&type=script&lang=js&"
export * from "./VueCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VueCheckbox.vue?vue&type=style&index=0&id=62f44558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f44558",
  null
  
)

export default component.exports